/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MonitEntityDataleaksStandardResult } from './MonitEntityDataleaksStandardResult';
import {
    MonitEntityDataleaksStandardResultFromJSON,
    MonitEntityDataleaksStandardResultFromJSONTyped,
    MonitEntityDataleaksStandardResultToJSON,
} from './MonitEntityDataleaksStandardResult';

/**
 * 
 * @export
 * @interface MonitEntityDataleaksStandardResponse
 */
export interface MonitEntityDataleaksStandardResponse {
    /**
     * 
     * @type {number}
     * @memberof MonitEntityDataleaksStandardResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitEntityDataleaksStandardResponse
     */
    page_size?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitEntityDataleaksStandardResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<MonitEntityDataleaksStandardResult>}
     * @memberof MonitEntityDataleaksStandardResponse
     */
    results: Array<MonitEntityDataleaksStandardResult>;
}

/**
 * Check if a given object implements the MonitEntityDataleaksStandardResponse interface.
 */
export function instanceOfMonitEntityDataleaksStandardResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function MonitEntityDataleaksStandardResponseFromJSON(json: any): MonitEntityDataleaksStandardResponse {
    return MonitEntityDataleaksStandardResponseFromJSONTyped(json, false);
}

export function MonitEntityDataleaksStandardResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitEntityDataleaksStandardResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'count': !exists(json, 'count') ? undefined : json['count'],
        'results': ((json['results'] as Array<any>).map(MonitEntityDataleaksStandardResultFromJSON)),
    };
}

export function MonitEntityDataleaksStandardResponseToJSON(value?: MonitEntityDataleaksStandardResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'count': value.count,
        'results': ((value.results as Array<any>).map(MonitEntityDataleaksStandardResultToJSON)),
    };
}

